import { ModuleDescriptionCard } from '@prometheus/features';
import { ModalContext, UseModalContext } from '@prometheus/hooks';
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Grid, Icon } from '@prometheus/components';
import { CreateDatabaseForm } from '../CreateDatabaseForm';
import { config } from './HomeWidget.config';
import { useTranslation } from 'react-i18next';
import { LastCreatedDataSources } from '../LastCreatedDataSources/LastCreatedDataSources';
export const HomeWidget = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { openModal, closeModal } = useContext<UseModalContext>(ModalContext);

  const { create } = config;

  const onCreateCdmDataSource = () => {
    openModal(
      () => (
        <CreateDatabaseForm
          createMethod={create}
          onCancel={closeModal}
          afterCreate={() => {
            closeModal();
            navigate('/admin/databases');
          }}
        />
      ),
      t('modals.create_database_header'),
      {
        closeOnClickOutside: true,
        onClose: closeModal,
        width: 700,
      }
    );
  };
  return (
    <ModuleDescriptionCard
      title={t('modules.administration.databases.header')}
      onClick={() => navigate('/admin/databases')}
      description={t('modules.administration.databases.list_databases')}
      iconName="dataCatalog"
      actions={
        <>
          <Button
            onClick={() => onCreateCdmDataSource()}
            variant="contained"
            color="success"
            name="save"
            startIcon={<Icon iconName="add" />}
          >
            {t('modules.administration.databases.create_database')}
          </Button>
          <Button
            onClick={() => navigate('/admin/databases')}
            variant="outlined"
            name="save"
            sx={{ ml: 1 }}
          >
            {t('buttons.view_all')}
          </Button>
        </>
      }
    >
      <Grid item xs={12} pt={2}>
        <LastCreatedDataSources t={t} />
      </Grid>
    </ModuleDescriptionCard>
  );
};
